import React, { useEffect, useState, createContext, useContext } from 'react';
import { View, Text, StyleSheet, ImageBackground, TextInput, FlatList } from 'react-native'
import { Link } from "react-router-dom";
import { FaTimesCircle, FaSave, FaEdit, FaBookOpen, FaBook, FaEraser, FaArrowCircleDown, FaHandPointUp, FaScroll, FaSun, FaMoon, FaSearchMinus, FaSearch, FaRunning, FaUserAltSlash, FaSyncAlt, FaGlobe, FaUsers, FaPeopleArrows, FaInfinity } from "react-icons/fa";
import Offcanvas from 'react-bootstrap/Offcanvas';
import Stack from 'react-bootstrap/Stack';
import Button from 'react-bootstrap/Button';
import ToggleButton from 'react-bootstrap/ToggleButton';
// import UserDetail from './UserDet.js';

import DataTable, { createTheme } from 'react-data-table-component';

import { format, fromUnixTime, addDays, startOfWeek, endOfWeek, addWeeks } from 'date-fns';

const UserPanel = () => {
  const apptsUrl = process.env.REACT_APP_APPTS_URL;
  const [isDev, setIsDev] = useState(apptsUrl.search('dev') > 0);
  const [pending, setPending] = React.useState(true);
  const styles = createStyles();
  // Active Sayer Filter button number 0,1,2
  const [activeOption, setActiveOption] = useState(0);
  // Sayer Group Filter button number 0,1,2
  const [groupOption, setGroupOption] = useState(0);
  // Archived Users
  const [archivedOption, setArchivedOption] = useState(false);
  const userClose = () => setShowUser(false);
  const [showUser, setShowUser] = useState(false);
  const [userRec, setUserRec] = useState(null);
  const [userEmail, setUserMail] = useState(null);

  const [curNow, setNow] = useState(new Date().toLocaleString());
  const [refreshInterval, setRefreshInterval] = useState(51000);
  const scrollTop = () => { window.scrollTo(0, 0); }
  const [stat1, setStat1] = useState(null);
  const btnNormal = "btn btn-sm btn-outline-info";
  const btnOn = "btn btn-sm btn-outline-warning";
  const btnActive = 'active ' + btnOn;
  const btnSelect = "btn btn-sm btn-warning";
  const btnSelectOn = 'active ' + btnNormal;
  const sortIcon = <FaArrowCircleDown />;
  const clickAchive = () => {
    // change archive state
    setArchivedOption(!archivedOption);
  }

  createTheme(
    'solarized',
    {
      text: {
        primary: 'goldenrod',
        secondary: 'orange',
      },
      background: {
        default: 'rgba(48, 0, 48, 0.2)',
      },
      context: {
        background: '#cb4b16',
        text: '#FFFFFF',
      },
      divider: {
        default: 'rgba(48, 0, 48, 0.5)',
      },
      button: {
        default: '#cb4b16',
        hover: 'rgba(0,0,0,.08)',
        focus: 'rgba(255,255,255,.12)',
        disabled: 'rgba(255, 255, 255, .34)',
      },
      sortFocus: {
        default: '#2aa198',
      },
    },
    'dark',
  );

  // Columns

  // function userActivate(userID, isLive) {
  //   // update user with id

  //   return;
  // };

  const updEmail = async (recid) => {
    var fullURL = `${apptsUrl}updUser?recid=${recid}`;
    fullURL = fullURL + `&userEmail=${userEmail}`;
    console.log('Upd User EMail', recid, fullURL);
    fetch(fullURL)
      .then(response => response.json())
      .then(data => {
        // console.log('User EMail', data);
        refreshMaster();
        alert(`User Email update, '${data}'`);
      })
      .catch(error => console.error(error));
  }

  function userArchive(recid, isDone) {
    // Update the Active state
    var fullURL = `${apptsUrl}updUser?recid=${recid}`;
    fullURL = fullURL + `&isDone=${isDone}`;
    console.log('Upd User Archive', recid, fullURL);
    fetch(fullURL)
      .then(response => response.json())
      .then(data => {
        // console.log('User isDone', data);
        refreshMaster();
        alert(`User Archive Status update, '${data}'`);
      })
      .catch(error => console.error(error));
  }

  function userPwdReset(recid) {
    // Update the Active state
    var fullURL = `${apptsUrl}updUser?recid=${recid}`;
    fullURL = fullURL + `&pwd=null`;
    console.log('Upd User Password', recid, fullURL);
    fetch(fullURL)
      .then(response => response.json())
      .then(data => {
        // console.log('User upd', data);
        refreshMaster();
        alert(`User Password Reset, '${data}'`);
        // window.location.reload();
      })
      .catch(error => console.error(error));
  }

  function userActivate(recid, isLive) {
    // Update the Active state
    var fullURL = `${apptsUrl}updUser?recid=${recid}`;
    fullURL = fullURL + `&isLive=${isLive}`;
    console.log('Upd User Active', recid, isLive, fullURL);
    fetch(fullURL)
      .then(response => response.json())
      .then(data => {
        // console.log('User upd', data);
        refreshMaster();
        alert(`User Updated, '${data}'`);
        // window.location.reload();
      })
      .catch(error => console.error(error));
  }

  function cell01(row) {
    // Active
    return (
      <div>
        <FaPeopleArrows style={row.userGroups === 'sayer' ? { display: 'inline' } : { display: 'none' }} />
        <FaGlobe style={row.userGroups === 'admin' ? { display: 'inline' } : { display: 'none' }} />&nbsp;
        {row.userName}
      </div>
    );
  };

  function cell02(row) {
    // Active
    return (
      <div>
        <Button id="email-fix" variant="outline-success" style={styles.isActive} active={true} onClick={() => [setUserRec(row), setUserMail(row.userEmail), setShowUser(true)]} ><FaEdit title='EDIT' /></Button>
        &nbsp;&nbsp;
        {row.userEmail}
      </div>
    );
  };

  function cell03(row) {
    // Active
    return (
      <div>
        <Button id="active-make" variant="outline-success" active={row.isLive < 10} disabled={row.isLive >= 10} style={styles.isActive} onClick={() => userActivate(row.recid, 10)} ><FaRunning title='ACTIVATE' /></Button>
        &nbsp;<Button id="active-inactive" variant="outline-danger" active={row.isLive >= 10} disabled={row.isLive < 10} style={styles.isInactive} onClick={() => userActivate(row.recid, 0)} ><FaUserAltSlash title='DEACTIVATE' /></Button>
        &nbsp;&nbsp;
        {row.isLive === 0 ? 'Inactive' : 'Active'}

      </div>
    );
  };

  function cell06(row) {
    // Reste Password
    return (
      <div>
        <Button id="reset-password" variant="outline-success" active={true} style={styles.isActive} onClick={() => userPwdReset(row.recid)} ><FaEraser title='RESET PASSWORD' /></Button>


      </div>
    );
  };

  function cell07(row) {
    // Archive
    return (
      <div>
        <Button id="archive-user-button" variant="outline-danger" active={!row.isDone || row.isDone === 0} style={styles.isActive} onClick={() => userArchive(row.recid, 1)} ><FaUserAltSlash title='ARCHIVE USER' /></Button>
        <Button id="archive-user-button" variant="outline-success" active={row.isDone === 1} style={styles.isInactive} onClick={() => userArchive(row.recid, 0)} ><FaUsers title='RETURN USER' /></Button>
      </div>
    );
  };

  const columns = [
    {
      id: "col01-Name",
      name: <div style={styles.texttall}>Name
      </div>,
      selector: row => row.userName,
      sortable: true,
      grow: 3,
      style: styles.textName,
      cell: row => cell01(row),
    },
    {
      id: "col02-EMail",
      name: <div style={styles.texttall}>E-Mail&nbsp;&nbsp;</div>,
      selector: row => row.userEmail,
      sortable: true,
      grow: 4,
      cell: row => cell02(row),
    },
    {
      id: "col03-Active",
      name: < div style={styles.texttall} > Active&nbsp;&nbsp;</div>,
      selector: row => row.isLive,
      sortable: true,
      grow: 2,
      cell: row => cell03(row),
      conditionalCellStyles: [
        {
          when: row => row.isLive !== 0,
          style: {
            backgroundColor: 'rgba(63, 195, 129, 0.2)',
            flex: 2,
            '&:hover': {
              cursor: 'pointer',
            },
          },
        },
        {
          when: row => row.isLive === 0,
          style: {
            backgroundColor: 'rgba(151, 0, 0, 0.2)',
            flex: 2,
            '&:hover': {
              cursor: 'pointer',
            },
          },
        },
      ],

    },
    {
      id: "col06-Reset",
      name: < div style={styles.texttall} >&nbsp;&nbsp;Reset</div>,
      selector: row => row.pwd,
      sortable: false,
      grow: 1,
      cell: row => cell06(row),
      conditionalCellStyles: [
        {
          when: row => row.pwd && row.pwd.length !== 0,
          style: {
            marginLeft: '10px',
            backgroundColor: 'rgba(63, 195, 129, 0.2)',
            flex: 1,
            '&:hover': {
              cursor: 'pointer',
            },
          },
        },
        {
          when: row => !row.pwd || row.pwd.length === 0,
          style: {
            marginLeft: '10px',
            backgroundColor: 'rgba(151, 0, 0, 0.2)',
            flex: 1,
            '&:hover': {
              cursor: 'pointer',
            },
          },
        },
      ],

    },
    {
      id: "col07-Archive",
      name: < div style={styles.texttall} >Archive</div>,
      selector: row => row.isDone,
      sortable: true,
      omit: !archivedOption,
      grow: 1,
      cell: row => cell07(row),
      conditionalCellStyles: [
        {
          when: row => row.isDone && row.isDone === 1,
          style: {
            backgroundColor: 'rgba(63, 195, 129, 0.2)',
            flex: 1,
            '&:hover': {
              cursor: 'pointer',
            },
          },
        },
        {
          when: row => !row.isDone || row.isDone === 0,
          style: {
            backgroundColor: 'rgba(151, 0, 0, 0.2)',
            flex: 1,
            '&:hover': {
              cursor: 'pointer',
            },
          },
        },
      ],

    },
    {
      id: "col04-Last",
      name: < div style={styles.texttall} >Last</div>,
      selector: row => row.lastLogin,
      sortable: true,
      format: row => format(fromUnixTime(row.lastLogin), 'MMM do yyyy'),
      grow: 1,
    },
    {
      id: "col05-Group",
      name: < div style={styles.texttall} >Group&nbsp;&nbsp;</div>,
      selector: row => row.userGroups,
      sortable: true,
      grow: 1,
    },
  ];

  // search
  const [userFilter, setUserFilter] = useState('');
  const [userInput, setUserInput] = useState('');
  const [filterStatActive, setStatActive] = useState(false);

  const clickSearch = (action) => {
    // Search names
    if (action === 'look') {
      setStatActive(true);
      setUserFilter(userInput);
      // setUserFilter('search-text');
    }
    if (action === 'clear') {
      setStatActive(false);
      setUserFilter('');
      setUserInput('');
    }
  }

  // Theme
  var ThemeBlob = { theme: 'dark' };
  const themeBlob = () => localStorage.getItem('UsersThemeBlob') ? JSON.parse(localStorage.getItem('UsersThemeBlob')) : ThemeBlob;
  const [dataColor, setDataColor] = React.useState(themeBlob().theme);
  const clickTheme = (theme) => {
    // Handle theme blob ops
    // build a fresh blob and save it
    setDataColor(theme);
    ThemeBlob.theme = theme;
    localStorage.setItem('UsersThemeBlob', JSON.stringify(ThemeBlob));
  }


  // get Master List
  const [masterlist, setMaster] = useState(null);
  // http://139.177.205.178:2095/scraperextracts
  // https://ctrl2.cherry2024.com:2096/getservers
  useEffect(() => {
    fetchMetrics();
    if (refreshInterval && refreshInterval > 0) {
      const interval = setInterval(refreshMaster, refreshInterval);
      return () => clearInterval(interval);
    }

  }, [refreshInterval]);

  // auto-refresh
  const refreshMaster = () => {
    // update time
    try {
      setNow(format(new Date().toLocaleString(), 'eee h:mm:ss'));
      fetchMetrics();

    } catch (error) {

    }
  };


  const fetchMetrics = () => {
    // retrieve and then setData()
    // https://dev.cherry2024.com:2096/getUsers
    // 
    fetch(`${apptsUrl}users`)
      .then(response => response.json())
      .then(data => {
        setMaster(data);
        setPending(false);
      })
      .catch(error => console.error(error));
  }

  const headerComponent = (
    <div>
      <span className='col' style={{ flex: 6, textAlign: 'left', fontSize: '1.5em' }}>
        Users
      </span>
      <span className='col' style={{ flex: 3 }}>
        &nbsp;&nbsp;&nbsp;Search:
        <TextInput
          style={styles.input}
          onChangeText={setUserInput}
          value={userInput}
          keyboardType="default"
        />
        <button id="search-go" style={{ backgroundColor: 'rgba(40, 0, 80, 0.51)', fontSize: '0.7em' }} className={btnOn} onClick={() => clickSearch('look')} ><FaSearch title='SEARCH' /></button>
        <button id="search-clear" style={{ backgroundColor: 'rgba(40, 0, 80, 0.51)', fontSize: '0.7em' }} className={btnOn} onClick={() => clickSearch('clear')} ><FaSearchMinus title='CLEAR SEARCH' /></button>
        &nbsp;
      </span>
      <span theme={dataColor} style={{ flex: 3, fontSize: '0.8em' }}>
        &nbsp;Active:
        <button id="active-make" className={activeOption === 1 ? btnActive : btnOn} onClick={() => setActiveOption(1)} ><FaRunning style={{ fontSize: '1.2em' }} title='ACTIVE' /></button>
        &nbsp;<button id="active-inactive" className={activeOption === 2 ? btnActive : btnOn} onClick={() => setActiveOption(2)} ><FaUserAltSlash style={{ fontSize: '1.2em' }} title='INACTIVE' /></button>
        &nbsp;<button id="active-all" className={activeOption === 0 ? btnActive : btnOn} onClick={() => setActiveOption(0)} ><FaInfinity style={{ fontSize: '1.2em' }} title='ALL' /></button>
        &nbsp;&nbsp;&nbsp;
      </span>
      <span theme={dataColor} style={{ flex: 3, fontSize: '0.8em' }}>
        &nbsp;Group:
        <button id="active-make" className={groupOption === 1 ? btnActive : btnOn} onClick={() => setGroupOption(1)} ><FaGlobe style={{ fontSize: '1.2em' }} title='ADMINS' /></button>
        &nbsp;<button id="active-inactive" className={groupOption === 2 ? btnActive : btnOn} onClick={() => setGroupOption(2)} ><FaPeopleArrows style={{ fontSize: '1.2em' }} title='SAYERS' /></button>
        &nbsp;<button id="active-all" className={groupOption === 0 ? btnActive : btnOn} onClick={() => setGroupOption(0)} ><FaInfinity style={{ fontSize: '1.2em' }} title='ALL' /></button>
        &nbsp;&nbsp;&nbsp;
      </span>
      <span theme={dataColor} style={{ flex: 3, fontSize: '0.8em' }}>
        &nbsp;Archive:
        <button id="archive-mode" className={archivedOption ? btnActive : btnOn} onClick={() => clickAchive()} >{archivedOption ? <FaBookOpen title='Archive' /> : <FaBook title='Archive' />}</button>
      </span>
      <span style={{ flex: 3, fontSize: '0.8em' }}>
        &nbsp;&nbsp;Last:{curNow}&nbsp;
        <button title='REFRESH' className={btnOn} onClick={() => window.location.reload()}><FaSyncAlt /></button>
      </span>
      <span className='col' style={{ flex: 3 }}>
        &nbsp;<button className={btnOn} onClick={() => clickTheme('default')} ><FaSun title='LIGHT THEME' /></button>
        &nbsp;<button className={btnOn} onClick={() => clickTheme('solarized')} ><FaMoon title='DARK THEME' /></button>
      </span>
      &nbsp;{isDev ? <span className="runningman down">DEV</span> : <span className="runningman up">Live</span>}
      <Offcanvas show={showUser} className="mt-2">
        <Offcanvas.Header className="sidebarright">
          <Offcanvas.Title>User E-Mail</Offcanvas.Title>
          <button className="btn btn-sm btn-outline-warning" onClick={userClose}>Close</button>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Stack className="sidebarright" gap={3}>
            <div className="p-2 rowodd row-fluid">
              User:&nbsp;<Text style={styles.textName} >{userRec ? userRec.userName : ''}&nbsp;&nbsp;&nbsp;</Text>
              <hr></hr>
              <h4>Enter E-Mail below:</h4>
              <TextInput
                style={styles.inputOff}
                onChangeText={setUserMail}
                multiline='true'
                value={userEmail}
                placeholder="Enter E-Mail Here"
                keyboardType="default"
              />
            </div>
            <div className="p-2 rowodd row-fluid">
              <Button title="UPDATE E-Mail" onClick={() => [userRec && updEmail(userRec.recid), setShowUser(false)]}>UPDATE E-Mail for {userRec ? userRec.userName : ''}</Button>
              <hr></hr>
              <span  >You are here to view/update the user e-mail.</span><br></br><br></br>
              <span  >You can change it at any time. Enter a new e-mail address and Update.&nbsp;&nbsp;&nbsp;</span><br></br><br></br>
              <span  >Enter an e-mail and update or Close if all you needed was the e-mail.&nbsp;&nbsp;&nbsp;</span><br></br>
            </div>
          </Stack>
        </Offcanvas.Body>
      </Offcanvas>

    </div>
  );

  function userGrid() {
    return (
      <DataTable
        columns={columns}
        data={masterlist.filter((r) =>
          (!filterStatActive || r.userName.toLowerCase().includes(userFilter.toLowerCase()))
          && (!activeOption || (activeOption === 1 && r.isLive > 0) || (activeOption === 2 && r.isLive === 0))
          && (!groupOption || (groupOption === 1 && r.userGroups === 'admin') || (groupOption === 2 && r.userGroups === 'sayer'))
          && (archivedOption || !archivedOption && !(r.isDone && r.isDone === 1))
        )}
        dense='true'
        theme={dataColor}
        striped='true'
        progressPending={pending}
        highlightOnHover={true}
        fixedHeader={true}
        title={headerComponent}
        defaultSortFieldId={'col01-Name'}
        sortIcon={sortIcon}
      // defaultSortField="col01-Name"

      />
    );
  };

  return (
    <div>
      {masterlist ?
        <div style={{ paddingTop: 35 }}>
          {userGrid()}
        </div>
        : <div className="detailtxt"><h4>&nbsp;&nbsp;Loading Users...</h4></div>}
    </div>
  );
};

export default UserPanel;


function createStyles() {
  return StyleSheet.create({
    container: {
      flex: 1,
      flexDirection: 'column',
      backgroundColor: 'black',
      // backgroundColor: theme.background,
    },
    input: {
      // height: 30,
      // marginBlockStart: 10,
      marginRight: 0,
      borderWidth: 2,
      borderColor: 'gold',
      padding: 2,
      fontSize: '1.0em',
      color: 'white',
      backgroundColor: 'rgba(40, 0, 80, 0.51)',
      display: 'inline-block',
      justifyContent: "flex-end",
      flexDirection: "column",
      width: "150px",
    },

    inputOff: {
      borderWidth: 2,
      borderColor: 'gold',
      padding: 5,
      fontSize: '1.2em',
      color: 'white',
      backgroundColor: 'rgba(40, 0, 80, 0.51)'
    },

    text: {
      color: 'goldenrod',
      fontSize: '1.1em',
      textAlign: 'left',
      flex: 2,
    },
    textName: {
      fontSize: '1.3em',
      flex: 3,
    },
    isActive: {
      fontSize: '1em',
      // backgroundColor: 'transparent',
      opacity: 0.5
    },
    isInactive: {
      fontSize: '1em',
      opacity: 0.5
    },
    activeState: {
      opacity: 0.5
    },

    texttall: {
      fontSize: '1.3em',
      marginLeft: '10px',
    },
    hdr1: {
      fontSize: '1.3em',
      width: '10%'
    },
    hdr2: {
      fontSize: '1.3em',
      width: '20%'
    },
    hdr3: {
      fontSize: '1.3em',
      width: '30%'
    },
    editOn: {
      display: "block",
    },
    editOff: {
      display: "none"

    },

    text1: {
      // color: theme.text,
      color: 'white',
      fontSize: '1.2em',
      fontWeight: 'bold',
      textAlign: 'left',
      // backgroundColor: theme.rowbg,
      backgroundColor: '#202',
      flex: 2,
    },
    text1thin: {
      // color: theme.text,
      color: 'white',
      fontSize: '1.2em',
      fontWeight: 'bold',
      textAlign: 'left',
      // backgroundColor: theme.rowbg,
      backgroundColor: '#202',
      flex: 1,
    },

    image: {
      height: '100%',
      width: 'auto',
      flex: 1,
      justifyContent: 'center',
    }
  })
}


